(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    const trigger = document.querySelector('.header__search');
    const live = document.querySelector('[data-live-search]');
    const input = document.getElementById('live-search-input');
    const cancelBtn = document.getElementById('cancel-button');
    const results = document.getElementById('live-search-results');
    const overlay = document.getElementById('search-bar-overlay');

    if (!live || !input) return;

    let debounce;

    function openSearch() {
      live.classList.remove('live-search--hidden');
      input.focus();
      overlay.classList.remove('overlay--hidden');
    }

    function closeSearch() {
      live.classList.add('live-search--hidden');
      overlay.classList.add('overlay--hidden');
    }

    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        openSearch();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', (e) => {
        e.stopPropagation();
        closeSearch();
      });
    }

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!live.contains(e.target) && !(trigger && trigger.contains(e.target))) {
        closeSearch();
      }
    });

    // Close on cancel button click
    cancelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeSearch();
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSearch();
    });

    // Handle Enter key to submit search
    const searchForm = document.querySelector('.search__form');

    if (searchForm) {
      searchForm.addEventListener('submit', (e) => {
        const query = input.value.trim();
        if (query.length === 0) {
          e.preventDefault();
        }
        // If query exists, let form submit naturally
      });
    }

    // Predictive search input handling
    input.addEventListener('input', () => {
      clearTimeout(debounce);

      const query = input.value.trim();

      if (query.length < 1) {
        results.innerHTML = '';
        return;
      }

      debounce = setTimeout(() => {
        const url = `/search?q=${encodeURIComponent(query)}` + `&type=product` + `&sections=predictive-search-products`;

        fetch(url)
          .then((res) => res.json())
          .then((data) => {
            results.innerHTML = data['predictive-search-products'] || '';
          });
      }, 300);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-proof-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.social-proof-card--with-products').forEach((card) => {
      const track = card.querySelector('.product-slider__track');
      const prevBtn = card.querySelector('.social-btn-previous');
      const nextBtn = card.querySelector('.social-btn-next');

      if (!track || !nextBtn) return;

      const getSlideWidth = () => {
        const firstCard = track.querySelector('.small-product-card');
        return firstCard ? firstCard.offsetWidth : track.offsetWidth;
      };

      nextBtn.addEventListener('click', () => {
        console.log('next clicked');
        track.scrollBy({
          left: getSlideWidth(),
          behavior: 'smooth',
        });
      });

      prevBtn?.addEventListener('click', () => {
        track.scrollBy({
          left: -getSlideWidth(),
          behavior: 'smooth',
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
